export default {
    name: 'Configuration',
    props: {
        uuidIntervener: {
            type: String,
            required: true
        },
        uuidAccount: {
            type: String,
            required: true
        },
        isHideAccount: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            hideAccount: this.isHideAccount,
            isLoading: false
        };
    },

    computed: {
        areChanges() {
            return this.isHideAccount !== this.hideAccount;
        }
    },

    methods: {
        cancel() {
            this.hideAccount = this.isHideAccount;
        },

        getChanges() {
            const changes = {};

            if (this.isHideAccount !== this.hideAccount) {
                changes.is_hidden_account = this.hideAccount;
            }

            return changes;
        },

        async saveChanges() {
            this.isLoading = true;

            const configuration = {
                configuration: this.getChanges()
            };

            if (Object.keys(configuration).length) {
                await this.$accountService.updateAccountIntervenerConfiguration(
                    {},
                    this.uuidAccount,
                    this.uuidIntervener,
                    configuration
                );

                this.$emit('updated-configuration');
                this.isLoading = false;
            } else {
                this.isLoading = false;
            }
        }
    }
};
